const formatNumber = (myNumber) => {
    const formattedNumber = new Intl.NumberFormat('ua-UA').format(myNumber);

    return formattedNumber;
};

const formatPercent = (n, fixed) => ~~(Math.pow(10, fixed) * n) / Math.pow(10, fixed);

export default {formatNumber, formatPercent};
